import React, { useState, useEffect } from 'react';
import CloseButton from '../../../sharecomponents/CloseButton copy';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../utils/Verifiers.jsx';
import { set } from 'lodash';

const EditorRendimientoSiembra = (p) => {
    const data = p.data;
    const args = p.args ?? {};
    const close = p.close ?? (() => { });
    const [rendimiento, setrendimiento] = useState(0);
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    useEffect(() => {

    }, []);

    const actualizarRendimiento = async () => {
        let arg = { ...args, 'unidad_hora': rendimiento, 'planIDUpdate': data?.id };
        let resp = await Post('catalogos/rendimiento/desde_plan', arg, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Ocurrió un error', 'error');
            return;
        }
        close(resp);
    }

    return (
        <>
            <div className='vw-100 vh-100 blur-xl bg-white4 p-0 m-0' style={{ overflow: 'auto', position: "fixed", top: 0, left: 0, zIndex: 99 }}>
                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <div className='bw-900 mt-5 p-1 bg-white shadow-multi round-m'>
                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                            <div className='w-100 h4 text-bold text-center'>Edicion de rendimiento</div>
                            <div className='w-70 border-bottom border-warning mb-3' />
                            <div className='w-100' />
                            <div className='bw-400 text-m text-center'>Nombre: <span className='text-bold'>SIEMBRA - {data?.flor?.toUpperCase()} {data?.variedad?.toUpperCase()}</span></div>
                            <div className='bw-200 text-m text-center'>Unidad: <span className='text-bold'>Charola</span></div>
                            <div className='w-100 mt-3' />
                            <div className='form-group bw-400 mb-5'>
                                <label className='text-bold w-100 ps-2'>Charolas por hora</label>
                                <input type='number' step={0.5} className='form-control shadow' value={rendimiento} onChange={(e) => setrendimiento(e?.target?.value)} />
                                <div className='w-100 text-center  mt-3'>
                                    <button className='btn btn-warning p-0 shadow bw-300 round-xxl' disabled={rendimiento <= 0} onClick={actualizarRendimiento}>GuardarCambios</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-100'></div>
                    <CloseButton close={() => close(false)} floatElement={true} />
                    {false && <div className='bw-600 mt-5 bg-white round-m'>
                        <pre className='w-100'>{JSON.stringify(data, null, 2)}</pre>
                    </div>}

                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </>
    )
}

export default EditorRendimientoSiembra;